import React from 'react';

const SupportPage = () => {
  const contactEmail = "info@ekovaruh.si";
  return (
    <div className="content p-4">
      <h2>Podpora aplikacije Eko Varuh</h2>

      <p>Hvala, ker uporabljate Eko Varuh. Tukaj smo, da vam pomagamo!</p>

      <p>Če naletite na kakršnekoli težave, imate vprašanja ali potrebujete pomoč pri uporabi aplikacije, nas prosimo
        kontaktirajte.</p>

      <b>Kontaktni podatki</b>
      <p>Za podporo nam pišite na: <a href={`mailto:${contactEmail}`}>{contactEmail}</a></p>

      <p>Prizadevamo si odgovoriti na vsa vprašanja v roku 24-48 ur.</p>

      <p>Hvala, ker nam pomagate ohranjati okolje čisto in varno!</p>
    </div>
  )
}

export default SupportPage;